// ABOUTME: Watchlist CRUD API client (list, get, create, update, delete + items)
// ABOUTME: Covers /watchlists/* endpoints

import type { ApiSuccessResponse } from '@alpha-finder/contracts/envelope';
import type {
  CreateWatchlistItemRequest,
  CreateWatchlistRequest,
  UpdateWatchlistItemRequest,
  UpdateWatchlistRequest,
  Watchlist,
  WatchlistItem,
  WatchlistList,
  WatchlistWithItems,
} from '@alpha-finder/contracts/watchlist';
import { apiClient } from './client';

export const watchlistApi = {
  async list(): Promise<WatchlistWithItems[]> {
    const response = await apiClient.get<ApiSuccessResponse<WatchlistList>>('/watchlists');
    return response.data.data.watchlists;
  },

  async get(id: string): Promise<WatchlistWithItems> {
    const response = await apiClient.get<ApiSuccessResponse<WatchlistWithItems>>(
      `/watchlists/${id}`
    );
    return response.data.data;
  },

  async create(data: CreateWatchlistRequest): Promise<Watchlist> {
    const response = await apiClient.post<ApiSuccessResponse<Watchlist>>('/watchlists', data);
    return response.data.data;
  },

  async update(id: string, data: UpdateWatchlistRequest): Promise<Watchlist> {
    const response = await apiClient.put<ApiSuccessResponse<Watchlist>>(`/watchlists/${id}`, data);
    return response.data.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/watchlists/${id}`);
  },

  async addItem(watchlistId: string, data: CreateWatchlistItemRequest): Promise<WatchlistItem> {
    const response = await apiClient.post<ApiSuccessResponse<WatchlistItem>>(
      `/watchlists/${watchlistId}/items`,
      data
    );
    return response.data.data;
  },

  async updateItem(
    watchlistId: string,
    itemId: string,
    data: UpdateWatchlistItemRequest
  ): Promise<WatchlistItem> {
    const response = await apiClient.put<ApiSuccessResponse<WatchlistItem>>(
      `/watchlists/${watchlistId}/items/${itemId}`,
      data
    );
    return response.data.data;
  },

  async deleteItem(watchlistId: string, itemId: string): Promise<void> {
    await apiClient.delete(`/watchlists/${watchlistId}/items/${itemId}`);
  },
};
